/** Как на бэкенде: +7XXXXXXXXXX или null */
export function normalizeRuPhone(s: string): string | null {
  if (!s?.trim()) return null;
  const d = s.replace(/\D/g, "");
  let n = d;
  if (n.length === 11 && n[0] === "8") n = "7" + n.slice(1);
  if (n.length === 10) n = "7" + n;
  if (n.length === 11 && n[0] === "7") return `+${n}`;
  return null;
}

export function isValidRuMobilePhone(s: string): boolean {
  const normalized = normalizeRuPhone(s);
  if (!normalized) return false;
  return /^\+7[3-9]\d{9}$/.test(normalized);
}

export function formatRuPhoneInput(s: string): string {
  const digits = s.replace(/\D/g, "");
  if (!digits) return "";

  const normalizedDigits = digits.startsWith("8") ? digits.slice(1) : digits;
  // Зажатый «+» на мобильной клавиатуре вставляет «0» — ведущий ноль не должен попадать в маску
  const limitedDigits = normalizedDigits.replace(/^7/, "").replace(/^0+/, "").slice(0, 10);

  if (!limitedDigits) return "";

  // Формат с пробелами по просьбе QA: +7 (999) 123-45-67
  const body = limitedDigits;
  if (body.length <= 3) return `+7 (${body}`;
  if (body.length <= 6) return `+7 (${body.slice(0, 3)}) ${body.slice(3)}`;
  if (body.length <= 8) return `+7 (${body.slice(0, 3)}) ${body.slice(3, 6)}-${body.slice(6)}`;
  return `+7 (${body.slice(0, 3)}) ${body.slice(3, 6)}-${body.slice(6, 8)}-${body.slice(8, 10)}`;
}

export function validateEmailFormat(s: string): { valid: boolean; error: string | null } {
  const trimmed = s.trim();
  if (!trimmed) return { valid: false, error: null };
  if (/[а-яё]/i.test(trimmed)) {
    return { valid: false, error: "Необходимо использовать латинские буквы" };
  }
  const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
  if (!emailPattern.test(trimmed)) {
    return { valid: false, error: "Неверный формат email" };
  }
  return { valid: true, error: null };
}
